import { useTranslation } from 'react-i18next';
import { Card, Group, Image, SimpleGrid, Stack, Text } from '@mantine/core';

interface BenefitItem {
  readonly key: string;
  readonly icon: string;
}

interface BenefitsProps {
  // На светлом фоне (about) — три преимущества на ОДНОЙ общей белой панели (вертикальные элементы);
  // по умолчанию — для тёмно-зелёного hero (горизонтальные элементы, без панели).
  readonly onLight?: boolean;
}

const ITEMS: readonly BenefitItem[] = [
  { key: 'offers', icon: 'benefit-diamond' },
  { key: 'logistics', icon: 'benefit-logistic' },
  { key: 'process', icon: 'benefit-process' },
];

// Три преимущества (иконки из фирменного набора benefit-*).
export default function Benefits({ onLight = false }: BenefitsProps) {
  const { t } = useTranslation();

  // /about: единая белая панель — все три преимущества на общем фоне, без отдельных карточек.
  if (onLight) {
    return (
      <Card withBorder bg="white" radius={0} padding="xl">
        <SimpleGrid cols={{ base: 1, sm: 3 }} spacing="xl" verticalSpacing="lg">
          {ITEMS.map(({ key, icon }) => (
            <Stack key={key} gap="xs">
              <Image src={`/images/icons/${icon}.svg`} alt="" w={40} h={40} />
              <Text fw={600}>{t(`landing.benefits.${key}.title`)}</Text>
              <Text size="sm" c="gray.7">
                {t(`landing.benefits.${key}.text`)}
              </Text>
            </Stack>
          ))}
        </SimpleGrid>
      </Card>
    );
  }

  // hero (тёмно-зелёный фон): горизонтальные элементы, без панели.
  return (
    <SimpleGrid cols={{ base: 1, sm: 3 }} spacing="lg">
      {ITEMS.map(({ key, icon }) => (
        <Group key={key} wrap="nowrap" align="flex-start" gap="sm">
          <Image src={`/images/icons/${icon}.svg`} alt="" w={40} h={40} />
          <Stack gap={2}>
            <Text fw={600} c="white">
              {t(`landing.benefits.${key}.title`)}
            </Text>
            <Text size="sm" c="gray.3">
              {t(`landing.benefits.${key}.text`)}
            </Text>
          </Stack>
        </Group>
      ))}
    </SimpleGrid>
  );
}
